export const TokenRedemptionTypes: { [key in TokenRedemptionType]: string } = {
  execution: 'Исполнение обязательств',
  // termination: 'Иное прекращение обязательств',
};

export enum TokenRedemptionType {
  execution = 'execution',
  // termination = 'termination',
}

export enum TokenRedemptionDocumentType {
  PAYMENT_DOC = "PAYMENT_DOC",
  NOTIFY_REDEEM_DOC = "NOTIFY_REDEEM_DOC",
  NOTIFY_REDEEM_DOC_SIG = "NOTIFY_REDEEM_DOC_SIG",
  AGREEMENT_DOC = "AGREEMENT_DOC",
  AGREEMENT_DOC_SIG = "AGREEMENT_DOC_SIG"
}

export enum BackendTokenRedemptionType {
  AGREEMENT = 'AGREEMENT',
  OTHER = 'OTHER',
}

export const MapTokenRedemptionTypeToBackendType: {
  [key in TokenRedemptionType]: BackendTokenRedemptionType;
} = {
  execution: BackendTokenRedemptionType.AGREEMENT,
  // termination: BackendTokenRedemptionType.OTHER,
};

export enum TokenRedemptionState {
  INIT = 'INIT',
  SIGN_TRANSACTION = 'SIGN_TRANSACTION',
  PAY = 'PAY',
  SIGN_PAY = 'SIGN_PAY',
  RESULT = 'RESULT',
  PAYMENT_SIGNED = 'PAYMENT_SIGNED',
  OWNER_SIGN_TRANSACTION = 'OWNER_SIGN_TRANSACTION',
  OWNER_RESULT = 'OWNER_RESULT',
  REDEEMED = 'REDEEMED',
}

export enum AssetBackendStatus {
  ACTIVE = 'ACTIVE',
  REDEEM_INITIALIZED = 'REDEEM_INITIALIZED',
  REDEEM_PAYMENT_UPLOADED = 'REDEEM_PAYMENT_UPLOADED',
  REDEEM_PAYMENT_SIGNED = 'REDEEM_PAYMENT_SIGNED',
  OWNER_PAYMENT_SIGNED = 'OWNER_PAYMENT_SIGNED',
  REDEEMED = 'REDEEMED',
}

export const AssetStatusToFrontendState: {
  [key: string]: TokenRedemptionState;
} = {
  ACTIVE: TokenRedemptionState.INIT,
  REDEEM_INITIALIZED: TokenRedemptionState.PAY,
  REDEEM_PAYMENT_UPLOADED: TokenRedemptionState.SIGN_PAY,
  REDEEM_PAYMENT_SIGNED: TokenRedemptionState.PAYMENT_SIGNED,
  OWNER_PAYMENT_SIGNED: TokenRedemptionState.OWNER_SIGN_TRANSACTION,
  REDEEMED: TokenRedemptionState.REDEEMED,
};

export interface SignRedeemNotificationPayload {
  tokenId: string;
  hash: string;
  checksum: string;
  signature: string;
  accountId: number;
}
